import { getAmplitudeInstance } from '../amplitudeHelpers';
import ReviewChip from '../enums/ReviewChip';

type logTrailDetailsDifficultyTappedParams = {
  trail_difficulty: ReviewChip;
  trail_id: number;
};

/**
 * The user taps on the linked trail difficulty text which opens the difficulty sheet.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_difficulty - the difficulty rating of the trail at the time of the user interaction
 * @param params.trail_id - the trail id of the item the user selected
 */
const logTrailDetailsDifficultyTapped = ({ trail_difficulty, trail_id }: logTrailDetailsDifficultyTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details difficulty tapped', { 'trail difficulty': trail_difficulty, 'trail id': trail_id }, callback);
};

export default logTrailDetailsDifficultyTapped;
